import type {EditorStarterItem} from '../../vendor/src/features/remotion-editor/editor/items/item-type';
import {SourceSceneSpecInspector} from './SourceSceneSpecInspector';
import {SourceBrandIntroInspector} from './SourceBrandIntroInspector';
import {SourceSlideInspector} from './SourceSlideFields';
import {SourceTextInspector} from './SourceTextInspector';
import {CinematicMotionInspector} from './CinematicMotionInspector';
import {CinematicMaskInspector} from './CinematicMaskInspector';

/** Stable component keys preserve global drafts when selection changes DOM order. */
export function SourceInspectorPanels({item}: {item?: EditorStarterItem}) {
  const priority = item?.sourceBrandIntro ? 'brand' : item?.sourceSlide ? 'slide' : item?.sourceText ? 'text'
    : item?.cinematicMotion ? 'motion' : item?.sourceScene && (item.type === 'video' || item.type === 'image') ? 'scene' : null;
  const panels = [
    <SourceBrandIntroInspector key="brand"/>, <SourceSlideInspector key="slide"/>,
    <CinematicMotionInspector key="motion"/>, <SourceTextInspector key="text"/>,
    <SourceSceneSpecInspector key="scene"/>, <CinematicMaskInspector key="mask"/>,
  ];
  const ordered = [...panels.filter(panel => panel.key === priority), ...panels.filter(panel => panel.key !== priority)];
  return <div className="source-inspector-tools">{ordered}</div>;
}
